import {
  faFileLines,
  faLayerGroup,
  faShapes,
  faWindowMaximize,
} from '@fortawesome/free-solid-svg-icons';
import { MAX_LAYERS } from '$lib/core/script';
import DocumentPanel from './DocumentPanel.svelte';
import LayersPanel from './LayersPanel.svelte';
import OutlinerPanel from './OutlinerPanel.svelte';
import ViewsPanel from './ViewsPanel.svelte';
import type { PanelSection } from './panel-section';

/** In rail order: the greatest scope first, down to the smallest. */
export const LEFT_PANEL_SECTIONS: readonly PanelSection[] = [
  {
    id: 'document',
    label: 'Document',
    icon: faFileLines,
    body: DocumentPanel,
  },
  {
    id: 'layers',
    label: 'Layers',
    icon: faLayerGroup,
    body: LayersPanel,
    add: {
      label: 'Add layer',
      title: 'Add a layer the script reads as layers.name',
      run: (editor) => editor.addLayer(),
      disabled: (editor) => editor.layers.length >= MAX_LAYERS,
    },
  },
  {
    id: 'views',
    label: 'Views',
    icon: faWindowMaximize,
    body: ViewsPanel,
  },
  {
    id: 'objects',
    label: 'Objects',
    icon: faShapes,
    body: OutlinerPanel,
  },
];
